import { usersService } from "./users.service";

// Função para buscar dados do usuário (GET /api/v3/users)
async function users() {
  try {
    return await usersService.users();
  } catch (error) {
    console.error("Erro ao buscar dados do usuário:", error);
    return null;
  }
}

// Função para atualizar dados do usuário (PUT /api/v3/users)
async function updateUsers(payload) {
  try {
    return await usersService.updateUser(payload);
  } catch (error) {
    console.error("Erro ao atualizar dados do usuário:", error);
    throw error;
  }
}

async function deletePhotoUser(photo) {
  try {
    // Implementar se necessário
    console.log("Função deletePhotoUser não implementada");
    return null;
  } catch (error) {
    console.error("Erro ao deletar foto do usuário:", error);
    throw error;
  }
}

export const profileService = {
  users,
  updateUsers,
  deletePhotoUser,
};
